define('presentation/settings/billing/plans/presentationObjects/planPresentationObject',[
    'i18next',
    'constants/billingPackageTypeConstants'
], function() {
    return function() {
        const self = this;

        const _billingPackageTypes = require('constants/billingPackageTypeConstants');
        const _i18n = require('i18next');

        self.billingPackageId = null;
        self.packageId = "";
        self.type = ko.observable(0);
        self.name = "";
        self.price = "";
        self.metadata = ko.observableArray([]);

        self.isActive = ko.observable(true);
        self.isRetired = ko.observable(false);
        self.isOnboardingRequired = ko.observable(false);
        self.isOnboardingComplete = ko.observable(false);
        self.isSignatureService = ko.observable(false);

        self.includedChatSessions = null;
        self.pricePerAdditionalChatSession = null;

        self.includedOutboundContacts = null;
        self.pricePerAdditionalOutboundContact = null;

        self.includedMinutes = null;
        self.pricePerAdditionalMinute = null;

        self.includedPhoneNumbers = null;
        self.pricePerAdditionalPhoneNumber = null;

        self.includedScripts = null;
        self.pricePerAdditionalScript = null;

        self.includedUsers = null;
        self.pricePerAdditionalUser = null;

        self.label =  ko.pureComputed(() => {
            switch (self.type()){
                case _billingPackageTypes.telephony.id:
                    return _i18n.t('plans:labelTelephony');
                case _billingPackageTypes.liveReceptionist.id:
                    return _i18n.t('plans:labelLiveReceptionist');
                case _billingPackageTypes.webChat.id:
                    return _i18n.t('plans:labelWebChat');
                case _billingPackageTypes.outboundCalling.id:
                    return _i18n.t('plans:labelOutboundCalling');
                default:
                    return "";
            }
        });

        self.isInOnboarding = ko.pureComputed(() => {
            return self.isActive() && self.isOnboardingRequired() && !self.isOnboardingComplete();
        });

        self.isFlexPlan = ko.pureComputed(() => {
            return self.type() === _billingPackageTypes.telephony.id;
        });

        self.tags = ko.pureComputed(() => {
           return [
               {
                   isVisible: self.isActive() && self.isOnboardingComplete(),
                   cssClass: 'plans-list-item__tag--active',
                   label: _i18n.t('plans:tagActive')
               },
               {
                   isVisible: self.isInOnboarding(),
                   cssClass: 'plans-list-item__tag--onboarding',
                   label: _i18n.t('plans:tagOnboarding')
               },
               {
                   isVisible: self.isRetired(),
                   cssClass: '',
                   label: _i18n.t('plans:tagRetired')
               }
           ];
        });

        self.showMetadata = ko.pureComputed(() => {
            return self.metadata().length > 0;
        });


    };
});
